import { Col, Input } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addCardProps } from '../../actions';
import { IState } from '../../graphql/types';
import { formInputLength, handleInputChange } from '../utils';
import { CardFormField } from './CardFormField';
import CardFormTextArea from './CardFormTextArea';

import styles from './CardForm.module.css';

const DefinitionForm: React.FC<{ saving: boolean }> = ({ saving }) => {
  const dispatch = useDispatch();
  const text = useSelector<IState, string | undefined>(
    state => state.cardProps?.text as string | undefined
  );
  const term = useSelector<IState, string | undefined>(
    state => state.cardProps?.term as string | undefined
  );

  return (
    <div className={styles.formWrapper}>
      <Col span={24}>
        <CardFormField
          name="definitionTerm"
          fieldLabel="Term"
          defaultValue={term}
          customValidator={e => formInputLength(e.target.value, 45)}
          customRules={[
            { max: 45, message: 'Limit of 45 characters exceeded' },
          ]}
        >
          <Input
            autoFocus
            className="modal-form-input"
            onChange={handleInputChange(value =>
              dispatch(addCardProps('term', value))
            )}
            disabled={saving}
            placeholder="Nudiustertian"
          />
        </CardFormField>
      </Col>
      <Col span={24}>
        <CardFormTextArea
          className="definitionDescription"
          name="definitionDescription"
          fieldLabel="Description"
          defaultValue={text}
          rows={7}
          showCount
          maxLength={300}
          onChange={handleInputChange(value =>
            dispatch(addCardProps('text', value))
          )}
          disabled={saving}
          placeholder="Of or relating to the day before yesterday; very recent"
        />
      </Col>
    </div>
  );
};

export default DefinitionForm;
